import React from "react";
import { Hourglass } from "lucide-react";
import { products, upcomingProducts } from "../data/mock";
import ProductCard from "./ProductCard";

function UpcomingCard({ item }) {
  return (
    <article
      className="relative card-dotted rounded-3xl p-6 bg-[#FFF8E7]/60 hover:bg-[#FFF8E7] transition-colors"
    >
      <div className="absolute -top-3 right-5 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#0F0F10] text-[#FFE357] text-[11px] font-bold uppercase tracking-widest border-[1.5px] border-[#0F0F10]">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400"></span>
        </span>
        Live · docs soon
      </div>

      <div className="font-mono text-xs text-[#0F0F10]/50">UP-0{item.id}</div>
      <h4 className="mt-2 text-xl font-bold tracking-tight">{item.title}</h4>

      <div className="mt-4 flex flex-wrap gap-2">
        {item.tags.map((t) => (
          <span key={t} className="tag-pill">
            {t}
          </span>
        ))}
      </div>

      <div className="mt-6 flex items-center justify-between text-xs font-mono text-[#0F0F10]/50">
        <span>shipping soon</span>
        <span>—</span>
      </div>
    </article>
  );
}

export default function ProductsSection() {
  return (
    <section id="work" className="py-24 px-4 sm:px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0F0F10] text-[#FFE357] text-xs font-semibold uppercase tracking-widest mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FFE357]"></span>
              Built for work
            </div>
            <h2 className="text-5xl sm:text-6xl font-extrabold tracking-tight">
              <span className="squiggle">Products</span> that I built
            </h2>
            <p className="mt-4 text-lg text-[#0F0F10]/70 max-w-2xl">
              From enterprise data privacy platforms used in 30+ countries to therapy workflow tools that cut cost by 50%.
            </p>
          </div>
          <div className="font-mono text-sm text-[#0F0F10]/60">
            01 — 0{products.length}
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {products.map((p, idx) => (
            <ProductCard key={p.id} product={p} idx={idx} />
          ))}
        </div>

        {/* Coming Soon */}
        <div className="mt-24">
          <div className="flex items-end justify-between flex-wrap gap-6 mb-10">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#FFE357] text-[#0F0F10] text-xs font-semibold uppercase tracking-widest mb-3 border-[1.5px] border-[#0F0F10]">
                <Hourglass className="w-3.5 h-3.5" />
                Coming soon
              </div>
              <h3 className="text-3xl sm:text-4xl font-extrabold tracking-tight">
                Currently in the oven
              </h3>
              <p className="mt-3 text-[#0F0F10]/70 max-w-xl">
                These products are <span className="font-semibold">already live</span> — the case studies &amp; documentation are still being written and will land on this portfolio shortly.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {upcomingProducts.map((u) => (
              <UpcomingCard key={u.id} item={u} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
